import { getToken } from "../authorization/auth";
import { API_ENDPOINT } from "../authorization/const";

export async function getBilledData(client) {
    const res = await fetch(API_ENDPOINT + "booking/get-all/" + client + "/" + getToken());
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function generateInvoice(invoice) {
    invoice["token"] = getToken();
    const res = await fetch(API_ENDPOINT + "invoice/generate", {
        method: "POST",
        body: JSON.stringify(invoice)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export function getTotalPrice(booking, pickup, packaging, cn, client) {
    if (cn === null) return { "fuel": client.fuel_charge ?? 0, "gst": (client.gst_num ?? false) ? 18 : 0 };
    if (!cn) return { "fuel": 0, "gst": 0 };
    var price = 0, fuel = 0, gst = 0;
    booking.filter((itm) => {
        if (itm.cn_no === cn) {
            price = price + itm.amount + itm.other;
            fuel = fuel + itm.fuel;
            gst = gst + itm.gst;
            return true;
        }
        return false;
    });
    pickup.filter((itm) => {
        if (itm.cn_ref === cn) {
            price = price + itm.amount;
            return true;
        }
        return false;
    });
    packaging.filter((itm) => {
        if (itm.cn_ref === cn) {
            price = price + itm.amount;
            return true;
        }
        return false;
    });
    if (price === 0) return { "fuel": 0, "gst": 0 };
    const gst_per = Number(((gst * 100) / (price + fuel)).toFixed(2));
    const fuel_per = Number(((fuel * 100) / (price)).toFixed(2));
    return { "fuel": fuel_per, "gst": gst_per };
}

export const getInvoicePrice = (selected) => {
    var total = 0;
    selected.forEach((itm) => {
        total = total + itm.price;
    });
    return Number(total.toFixed(2));
}

export const getInvoiceFuel = (selected) => {
    return Number(selected.reduce((sum, item) => sum + item.fuel, 0).toFixed(2));
}

export const getInvoiceTaxable = (selected) => {
    return Number(selected.reduce((sum, item) => sum + item.price + item.fuel, 0).toFixed(2));
}

export const getInvoiceGst = (selected) => {
    return Number(selected.reduce((sum, item) => sum + item.gst, 0).toFixed(2));
}

export const getInvoiceTotalPrice = (selected) => {
    return Number(selected.reduce((sum, item) => sum + item.price + item.fuel + item.gst, 0).toFixed(2));
}
